import Vue from 'vue'
import App from './App.vue'
import VueJSModal from 'vue-js-modal'

Vue.config.productionTip = false
Vue.use(VueJSModal, { dialog: true, draggable: true, resizable: true })

const options = window.myShortcodeVars || {
  kidsEnabled: 'yes',
  dietEnabled: 'yes'
}

setTimeout(() => {
  new Vue({
    render: h => h(App),
    data: {
      kidsEnabled: options.kidsEnabled === 'yes',
      dietEnabled: options.dietEnabled === 'yes'
    }
  }).$mount('#app')
},1000)
